import React from 'react';
import { Flex, Image } from 'pcln-design-system';
var TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
export function TravelBotLogoImage(props) {
    return (React.createElement(Flex, { width: 32, height: 32, alignItems: 'center' },
        React.createElement(Image, { src: TRAVEL_BOT_LOGO, width: 32, alt: 'Penny chat avatar' })));
}
//# sourceMappingURL=TravelBotLogoImage.js.map